import { toast } from "react-toastify";
import { call, put, takeLatest, select } from "redux-saga/effects";
import { actions } from "..";
import { checkArray, checkNull, deepCopy } from "../../helpers";
import { menuServices } from "../../services";
import {
  changeMenuValue,
  getMenuPricingList,
  getEditMenuPricingList,
} from "../actions/menuActions";
import { showNotificationWithTimeout } from "../actions/toastActions";
import * as actionTypes from "../actionTypes";

let errMsg = "Something went wrong!";

function* getMenuIngredientDetails(action) {
  let menuDetail = null;
  const res = yield call(
    menuServices.getMenuIngredientDetails,
    action?.payload
  );
  console.log("GET_MENU_INGREDIENTS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_MENU_INGREDIENTS", res?.data);
      menuDetail = res?.data?.ingredients ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("ingredient_details", menuDetail));
}

function* addMenuIngredientDetail(action) {
  let menuDetail = null;
  const res = yield call(menuServices.addMenuIngredientDetail, action?.query);
  console.log("ADD_MENU_INGREDIENT_DETAILS", res);
  if (res) {
    if (res?.status) {
      console.log("ADD_MENU_INGREDIENT_DETAILS", res?.data);
      menuDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("ingredient_details", menuDetail));
}

function* saveMenuIngredientDetail(action) {
  let redirectVal = false;
  let res;
  if (checkNull(action?.payload?.id)) {
    res = yield call(
      menuServices.updateMenuIngredientDetail,
      `/${action?.payload?.id}`,
      action?.payload
    );
  } else {
    res = yield call(menuServices.saveMenuIngredientDetail, action?.payload);
  }
  console.log("SAVE_MENU_INGREDIENT_DETAILS", res);
  if (res) {
    if (res?.status) {
      console.log("SAVE_MENU_INGREDIENT_DETAILS", res?.data);
      redirectVal = true;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("is_redirect_menu_ingredient", redirectVal));
}

function* checkSupplierDetails(action) {
  let supllierDetail = null;
  const res = yield call(menuServices.checkSupplierDetails, action?.query);
  console.log("CHECK_SUPPLIER_DETAILS", res);
  if (res) {
    if (res?.status) {
      console.log("CHECK_SUPPLIER_DETAILS", res?.data);
      supllierDetail = res?.data?.return ?? 0;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("check_supplier_details", supllierDetail));
}
function* getConversionMultiplierDetails(action) {
  let conversionDetail = null;
  const res = yield call(
    menuServices.getConversionMultiplierDetails,
    action?.payload
  );
  console.log("GET_CONVERSION_MULTIPLIER", res);
  if (res) {
    if (res?.status) {
      console.log("GET_CONVERSION_MULTIPLIER", res?.data);
      conversionDetail = res?.data?.returnArr ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("ingredient_conversion_details", conversionDetail));
}

function* saveStorageAreaDetails(action) {
  yield put(changeMenuValue("is_add_storage_loading", true));
  const ingredient_details = yield select(
    (state) => state?.menuReducer?.ingredient_details
  );
  const add_item_details = yield select(
    (state) => state?.menuReducer?.add_item_details
  );
  let newStorageDetail = null;
  if (action?.payload?.actionFrom == "menu_item") {
    newStorageDetail = checkNull(add_item_details, false)
      ? { ...add_item_details }
      : null;
  } else {
    newStorageDetail = checkNull(ingredient_details, false)
      ? { ...ingredient_details }
      : null;
  }
  let newStorageId = "";
  const res = yield call(menuServices.saveStorageAreaDetails, action?.payload);
  console.log("SAVE_STORAGE_AREA_DETAILS", res);
  if (res) {
    if (res?.status) {
      console.log("SAVE_STORAGE_AREA_DETAILS", res?.data);
      yield put(changeMenuValue("storageAreaModalModal", false));
      if (
        checkNull(newStorageDetail, false) &&
        checkNull(res?.data?.storage_area)
      ) {
        if (action?.payload?.actionFrom == "menu_item") {
          if (action?.payload?.type == 1) {
            newStorageDetail.storage_area_1s = res?.data?.storage_area_1;
          } else {
            newStorageDetail.storage_area_2s = res?.data?.storage_area_2;
          }
        } else {
          newStorageDetail.storage_area = res?.data?.storage_area;
        }
      }
      if (checkNull(res?.data?.new_id)) {
        newStorageId = res?.data?.new_id;
      }
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("is_add_storage_loading", false));
  if (action?.payload?.actionFrom == "menu_item") {
    // for add menu item
    yield put(changeMenuValue("add_item_details", newStorageDetail));
  } else {
    // for add menu ingredient/recipe
    yield put(changeMenuValue("ingredient_details", newStorageDetail));
  }
  yield put(changeMenuValue("add_storage_new_id", newStorageId));
}

function* getInventoryUomDetail(action) {
  let uomDetail = null;
  const res = yield call(menuServices.getInventoryUomDetail, action?.payload);
  console.log("GET_INVENTORY_UOM", res);
  if (res) {
    if (res?.status) {
      console.log("GET_INVENTORY_UOM", res?.data);
      uomDetail = res?.data?.returnArr ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("inventory_uom_details", uomDetail));
}

function* saveBackupIngredientDetail(action) {
  yield put(changeMenuValue("backupIngredientModal_loading", true));
  const res = yield call(
    menuServices.saveBackupIngredientDetail,
    action?.payload
  );
  console.log("SAVE_BACKUP_INGREDIENT", res);
  if (res) {
    if (res?.status) {
      console.log("SAVE_BACKUP_INGREDIENT", res?.data);
      if (checkArray(res?.data?.settings)) {
        yield put(
          changeMenuValue("backup_ingredient_list", res?.data?.settings)
        );
      }
      yield put(changeMenuValue("backupIngredientModal", false));
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("backupIngredientModal_loading", false));
}

function* getBackupIngredientDetail(action) {
  let backupIngredientList = [];
  const res = yield call(menuServices.getBackupIngredientDetail, action?.query);
  console.log("SAVE_BACKUP_INGREDIENT", res);
  if (res) {
    if (res?.status) {
      console.log("SAVE_BACKUP_INGREDIENT", res?.data);
      backupIngredientList = checkArray(res?.data?.setts)
        ? res?.data?.setts
        : [];
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("backup_ingredient_list", backupIngredientList));
}

function* getEditIngredientDetail(action) {
  let editDetail = null;
  const res = yield call(menuServices.getEditIngredientDetail, action?.query);
  console.log("GET_EDIT_INGREDIENT", res);
  if (res) {
    if (res?.status) {
      console.log("GET_EDIT_INGREDIENT", res?.data);
      editDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("ingredient_details", editDetail));
}

function* getIngrRecMenuPendingApprovalDetail(action) {
  let pendingAppDetail = null;
  const res = yield call(
    menuServices.getIngrRecMenuPendingApprovalDetail,
    action?.query
  );
  console.log("GET_INGRE_MENU_APPROVAL", res);
  if (res) {
    if (res?.status) {
      console.log("GET_INGRE_MENU_APPROVAL", res?.data);
      pendingAppDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("ingredient_details", pendingAppDetail));
}

function* changePendIngredientStatusDetail(action) {
  const ingredient_details = yield select(
    (state) => state?.menuReducer?.ingredient_details
  );
  let newIngreList = { ...ingredient_details };
  const res = yield call(
    menuServices.changePendIngredientStatusDetail,
    action?.payload
  );
  console.log("CHANGE_PEND_INGREDIENT_STATUS", res);
  if (res) {
    if (res?.status) {
      console.log("CHANGE_PEND_INGREDIENT_STATUS", res?.data);
      newIngreList.ingredients = checkArray(res?.data?.ingredients)
        ? res?.data?.ingredients
        : [];
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("ingredient_details", newIngreList));
}

function* changeIngredientStatusDetail(action) {
  let redirectVal = false;
  const res = yield call(
    menuServices.changeIngredientStatusDetail,
    action?.payload
  );
  console.log("CHANGE_INGREDIENT_STATUS", res);
  if (res) {
    if (res?.status) {
      console.log("CHANGE_INGREDIENT_STATUS", res?.data);
      redirectVal = true;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("is_redirect_menu_ingredient", redirectVal));
}

function* getMenuRecipeDetails(action) {
  let menuDetail = null;
  const res = yield call(menuServices.getMenuRecipeDetails, action?.payload);
  console.log("GET_MENU_RECIPE", res);
  if (res) {
    if (res?.status) {
      console.log("GET_MENU_RECIPE", res?.data);
      menuDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("recipe_details", menuDetail));
}

function* addMenuRecipeDetail(action) {
  let menuDetail = null;
  const res = yield call(menuServices.addMenuRecipeDetail, action?.query);
  console.log("ADD_MENU_RECIPE_DETAILS", res);
  if (res) {
    if (res?.status) {
      console.log("ADD_MENU_RECIPE_DETAILS", res?.data);
      menuDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("recipe_details", menuDetail));
}

function* getMeasurementUnitDetails(action) {
  let muDetail = null;
  yield put(changeMenuValue("measurement_unit_details", muDetail));
  const res = yield call(menuServices.getMeasurementUnitDetails, action?.query);
  console.log("GET_MEASUREMENT_UNIT", res);
  if (res) {
    if (res?.status) {
      console.log("GET_MEASUREMENT_UNIT", res?.data);
      muDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("measurement_unit_details", muDetail));
}

function* getRecipeCostPriceDetails(action) {
  const recipe_details = yield select(
    (state) => state?.menuReducer?.recipe_details
  );
  let cprDetail = null;
  yield put(
    changeMenuValue("recipe_details", {
      ...recipe_details,
      cpr_detail: cprDetail,
    })
  );
  const res = yield call(
    menuServices.getRecipeCostPriceDetails,
    action?.payload
  );
  console.log("GET_RECIPE_COST_PRICE", res);
  if (res) {
    if (res?.status) {
      console.log("GET_RECIPE_COST_PRICE", res?.data);
      cprDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(
    changeMenuValue("recipe_details", {
      ...recipe_details,
      cpr_detail: cprDetail,
    })
  );
}

function* getRecipeMultiplierDetails(action) {
  const recipe_details = yield select(
    (state) => state?.menuReducer?.recipe_details
  );
  let multiplierDetail = null;
  yield put(
    changeMenuValue("recipe_details", {
      ...recipe_details,
      multiplier_detail: multiplierDetail,
    })
  );
  const res = yield call(
    menuServices.getRecipeMultiplierDetails,
    action?.payload
  );
  console.log("GET_RECIPE_MULTIPLIER", res);
  if (res) {
    if (res?.status) {
      console.log("GET_RECIPE_MULTIPLIER", res?.data);
      multiplierDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(
    changeMenuValue("recipe_details", {
      ...recipe_details,
      multiplier_detail: multiplierDetail,
    })
  );
}

function* getRecipeUnitPriceDetails(action) {
  const recipe_details = yield select(
    (state) => state?.menuReducer?.recipe_details
  );
  let unitPriceDetail = null;
  yield put(
    changeMenuValue("recipe_details", {
      ...recipe_details,
      unit_price_detail: unitPriceDetail,
    })
  );
  const res = yield call(
    menuServices.getRecipeUnitPriceDetails,
    action?.payload
  );
  console.log("GET_RECIPE_UNIT_PRICE", res);
  if (res) {
    if (res?.status) {
      console.log("GET_RECIPE_UNIT_PRICE", res?.data);
      unitPriceDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(
    changeMenuValue("recipe_details", {
      ...recipe_details,
      unit_price_detail: unitPriceDetail,
    })
  );
}

function* saveMenuRecipeDetail(action) {
  let redirectVal = false;
  let res;
  if (checkNull(action?.payload?.id)) {
    res = yield call(
      menuServices.updateMenuRecipeDetail,
      `/${action?.payload?.id}`,
      action?.payload
    );
  } else {
    res = yield call(menuServices.saveMenuRecipeDetail, action?.payload);
  }
  console.log("SAVE_MENU_INGREDIENT_DETAILS", res);
  if (res) {
    if (res?.status) {
      console.log("SAVE_MENU_INGREDIENT_DETAILS", res?.data);
      redirectVal = true;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("is_redirect_menu_recipe", redirectVal));
}

function* getEditRecipeDetail(action) {
  let editDetail = null;
  const res = yield call(menuServices.getEditRecipeDetail, action?.query);
  console.log("GET_EDIT_RECIPE", res);
  if (res) {
    if (res?.status) {
      console.log("GET_EDIT_RECIPE", res?.data);
      editDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("recipe_details", editDetail));
}

function* changePendRecipeStatusDetail(action) {
  const ingredient_details = yield select(
    (state) => state?.menuReducer?.ingredient_details
  );
  let newIngreList = { ...ingredient_details };
  const res = yield call(
    menuServices.changePendRecipeStatusDetail,
    action?.payload
  );
  console.log("CHANGE_PEND_RECIPE_STATUS", res);
  if (res) {
    if (res?.status) {
      console.log("CHANGE_PEND_RECIPE_STATUS", res?.data);
      newIngreList.recipes = checkArray(res?.data?.recipes)
        ? res?.data?.recipes
        : [];
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("ingredient_details", newIngreList));
}

/* Menu Items */
function* getMenuItemsDetails(action) {
  let menuDetail = null;
  const res = yield call(menuServices.getMenuItemsDetails, action?.payload);
  console.log("GET_MENU_ITEMS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_MENU_ITEMS", res?.data);
      menuDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("menu_item_details", menuDetail));
}

function* getMenuItemSubClassDetails(action) {
  let subClassDetail = null;
  const res = yield call(
    menuServices.getMenuItemSubClassDetails,
    action?.payload
  );
  console.log("GET_MENU_ITEM_SUB_CLASS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_MENU_ITEM_SUB_CLASS", res?.data);
      subClassDetail = res?.data?.sub_classes ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("item_subclass_detail", subClassDetail));
}

function* getMenuItemSubCategoryDetails(action) {
  let subCategoryDetail = null;
  const res = yield call(
    menuServices.getMenuItemSubCategoryDetails,
    action?.payload
  );
  console.log("GET_MENU_ITEM_SUB_CATEGORY", res);
  if (res) {
    if (res?.status) {
      console.log("GET_MENU_ITEM_SUB_CATEGORY", res?.data);
      subCategoryDetail = res?.data?.menus ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("item_subcategory_detail", subCategoryDetail));
}

function* updateMenuItemClassDetails(action) {
  let reloadFlag = null;
  const reload_list_flag = yield select(
    (state) => state?.menuReducer?.reload_list_flag
  );
  const res = yield call(
    menuServices.updateMenuItemClassDetails,
    action?.payload
  );
  console.log("UPDATE_MENU_ITEM_CLASS", res);
  if (res) {
    if (!res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
    reloadFlag = reload_list_flag == null ? true : !reload_list_flag;
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("reload_list_flag", reloadFlag));
}

function* updateMenuItemCategoryDetails(action) {
  let reloadFlag = null;
  const reload_list_flag = yield select(
    (state) => state?.menuReducer?.reload_list_flag
  );
  const res = yield call(
    menuServices.updateMenuItemCategoryDetails,
    action?.payload
  );
  console.log("UPDATE_MENU_ITEM_CATEGORY", res);
  if (res) {
    if (!res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
    reloadFlag = reload_list_flag == null ? true : !reload_list_flag;
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("reload_list_flag", reloadFlag));
}

function* updateMenuItemStatusDetails(action) {
  let reloadFlag = null;
  const reload_list_flag = yield select(
    (state) => state?.menuReducer?.reload_list_flag
  );
  const res = yield call(
    menuServices.updateMenuItemStatusDetails,
    action?.payload
  );
  console.log("UPDATE_MENU_ITEM_STATUS", res);
  if (res) {
    if (!res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
    reloadFlag = reload_list_flag == null ? true : !reload_list_flag;
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("reload_list_flag", reloadFlag));
}

function* editMenuItemLifespanDetails(action) {
  let itemLifespanDetails = null;
  const reload_list_flag = yield select(
    (state) => state?.menuReducer?.reload_list_flag
  );
  const res = yield call(
    menuServices.editMenuItemLifespanDetails,
    action?.payload
  );
  console.log("UPDATE_MENU_ITEM_STATUS", res);
  if (res) {
    if (res?.status) {
      itemLifespanDetails = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("item_lifespan_details", itemLifespanDetails));
}

function* updateMenuItemLifespanDetails(action) {
  const res = yield call(
    menuServices.updateMenuItemLifespanDetails,
    action?.payload
  );
  console.log("UPDATE_MENU_ITEM_LIFESPAN", res);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(changeMenuValue("updateItemLifespanModal", false));
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}
function* getMenuPricingDetails(action) {
  const res = yield call(menuServices?.getMenuPricingDetails, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveMenuPricingDetails(data));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* postMenuPricingDetails(action) {
  const res = yield call(menuServices?.postMenuPricingDetails, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* getScheduledMenuPricingDetails(action) {
  const res = yield call(
    menuServices?.getScheduledMenuPricingDetails,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveScheduledMenuPricingDetails(data));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* getAddMenuItemDetails(action) {
  let addMenuDetail = null;
  yield put(changeMenuValue("add_item_details", addMenuDetail));
  const res = yield call(menuServices.getAddMenuItemDetails, action?.query);
  console.log("GET_ADD_MENU_ITEM", res);
  if (res) {
    if (res?.status) {
      console.log("GET_ADD_MENU_ITEM", res?.data);
      addMenuDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("add_item_details", addMenuDetail));
  yield put(getMenuPricingList());
}

function* searchMenuByName(action) {
  const res = yield call(menuServices?.searchMenuByName, action?.payload);
  if (res?.status && res?.data) {
    const data = {
      searchList: res?.data?.result,
      uniqueId: action?.payload?.uniqueId,
    };
    yield put(actions?.saveSearchMenuResult(data));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* getSalesType(action) {
  const res = yield call(menuServices?.getSalesType, action?.payload);
  if (res?.status && res?.data) {
    const data = {
      salesList: res?.data,
      uniqueId: action?.payload?.uniqueId,
    };
    yield put(actions?.saveSalesType(data));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* postScheduledMenuPricingDetails(action) {
  const res = yield call(
    menuServices?.postScheduledMenuPricingDetails,
    action?.payload
  );
  if (res?.status && res?.data) {
    const newRes = res?.data?.data;
    yield put(actions?.saveScheduledMenuPricingDetails(newRes));
    yield put(
      actions.setModalState({
        modalName: "menu_new_pricing_modal_state",
        modalState: false,
      })
    );
    yield put(
      showNotificationWithTimeout(`${res?.data?.message ?? ""}`, "success")
    );
  } else {
    yield put(
      showNotificationWithTimeout(`${res?.data?.message ?? ""}`, "error")
    );
  }
}
function* deleteScheduledMenuItem(action) {
  const res = yield call(
    menuServices?.deleteScheduledMenuItem,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    console.log(res?.data, "9999999");
    yield put(actions?.saveScheduledMenuPricingDetails(data));
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* getMenuItemCaDetails(action) {
  yield put(changeMenuValue("item_ca_details", null));
  let menuItemCaDetail = null;
  const res = yield call(menuServices.getMenuItemCaDetails, action?.query);
  console.log("GET_MENU_ITEM_CA", res);
  if (res) {
    if (res?.status) {
      console.log("GET_MENU_ITEM_CA", res?.data);
      menuItemCaDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("item_ca_details", menuItemCaDetail));
}

function* getMenuMeasurementUnitDetails(action) {
  yield put(changeMenuValue("measurement_unit_details", null));
  let menuItemCaDetail = null;
  const res = yield call(
    menuServices.getMenuMeasurementUnitDetails,
    action?.query
  );
  console.log("GET_MENU_MEASUREMENT_UNIT", res);
  if (res) {
    if (res?.status) {
      console.log("GET_MENU_MEASUREMENT_UNIT", res?.data);
      menuItemCaDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("measurement_unit_details", menuItemCaDetail));
}

function* getMenuUnitPriceDetails(action) {
  const menuReducer = yield select((state) => state?.menuReducer);
  const unitPriceInput = action?.unitPriceInput ?? "unit_price_detail";
  const fromPage = action?.fromPage ?? "add_item_details";
  const selectedKey = menuReducer?.[fromPage];
  let unitPriceDetail = null;
  yield put(
    changeMenuValue(fromPage, {
      ...selectedKey,
      [unitPriceInput]: unitPriceDetail,
    })
  );
  const res = yield call(
    menuServices.getRecipeUnitPriceDetails,
    action?.payload
  );
  console.log("GET_MENU_UNIT_PRICE", res);
  if (res) {
    if (res?.status) {
      console.log("GET_MENU_UNIT_PRICE", res?.data);
      unitPriceDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(
    changeMenuValue(fromPage, {
      ...selectedKey,
      [unitPriceInput]: unitPriceDetail,
    })
  );
}

function* getMenuMultiUnitDetails(action) {
  const menuReducer = yield select((state) => state?.menuReducer);
  const multiUnitInput = action?.multiUnitInput ?? "multiplier_detail";
  const fromPage = action?.fromPage ?? "add_item_details";
  const selectedKey = menuReducer?.[fromPage];
  let multiUnitDetail = null;
  yield put(
    changeMenuValue(fromPage, {
      ...selectedKey,
      [multiUnitInput]: multiUnitDetail,
    })
  );
  const res = yield call(
    menuServices.getRecipeMultiplierDetails,
    action?.payload
  );
  console.log("GET_MENU_MULTI_UNIT", res);
  if (res) {
    if (res?.status) {
      console.log("GET_MENU_MULTI_UNIT", res?.data);
      multiUnitDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(
    changeMenuValue(fromPage, {
      ...selectedKey,
      [multiUnitInput]: multiUnitDetail,
    })
  );
}

function* getAddMenuPricingsDetails(action) {
  const add_item_details = yield select(
    (state) => state?.menuReducer?.add_item_details
  );
  const newAddItemDetails = deepCopy(add_item_details);
  let salesType = [];
  const res = yield call(menuServices.getAddMenuPricingsDetails, action?.query);
  console.log("GET_ADD_MENU_PRICINGS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_ADD_MENU_PRICINGS", res?.data);
      salesType = res?.data?.salesType ?? [];
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  newAddItemDetails.salesType = salesType;
  yield put(changeMenuValue("add_item_details", newAddItemDetails));
}

function* getMenuEditPricingsDetails(action) {
  const add_item_details = yield select(
    (state) => state?.menuReducer?.add_item_details
  );
  const newAddItemDetails = deepCopy(add_item_details);
  let salesType = [];
  const res = yield call(
    menuServices.getMenuEditPricingsDetails,
    action?.query
  );
  console.log("GET_MENU_EDIT_PRICINGS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_MENU_EDIT_PRICINGS", res?.data);
      salesType = res?.data?.salesType ?? [];
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  newAddItemDetails.salesType = salesType;
  yield put(changeMenuValue("add_item_details", newAddItemDetails));
}

function* getMenuPricingListDetails(action) {
  let pricingList = [];
  const res = yield call(menuServices.getMenuPricingListDetails, action?.query);
  console.log("GET_MENU_PRICING_LIST", res);
  if (res) {
    if (res?.status) {
      console.log("GET_MENU_PRICING_LIST", res?.data);
      pricingList = res?.data?.payments ?? [];
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("saved_pricings_details", pricingList));
}

function* getEditMenuPricingListDetails(action) {
  let pricingList = [];
  const res = yield call(
    menuServices.getEditMenuPricingListDetails,
    action?.query
  );
  console.log("GET_EDIT_MENU_PRICING_LIST", res);
  if (res) {
    if (res?.status) {
      console.log("GET_EDIT_MENU_PRICING_LIST", res?.data);
      pricingList = res?.data?.payments ?? [];
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("saved_pricings_details", pricingList));
}

function* saveAddMenuPricingsDetails(action) {
  const res = yield call(
    menuServices.saveAddMenuPricingsDetails,
    action?.payload
  );
  let savePricings = [];
  console.log("SAVE_ADD_MENU_PRICINGS", res);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      savePricings = res?.data?.payments ?? [];
      yield put(changeMenuValue("priceItemModal", false));
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("saved_pricings_details", savePricings));
}

function* saveEditMenuPricingsDetails(action) {
  const res = yield call(
    menuServices.saveEditMenuPricingsDetails,
    action?.payload
  );
  let savePricings = [];
  console.log("SAVE_EDIT_MENU_PRICINGS", res);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      savePricings = res?.data?.payments ?? [];
      yield put(changeMenuValue("priceItemModal", false));
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("saved_pricings_details", savePricings));
}

function* deleteMenuPricingsDetails(action) {
  const res = yield call(
    menuServices.deleteMenuPricingsDetails,
    action?.payload
  );
  let savePricings = [];
  console.log("DELETE_MENU_PRICINGS", res);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      savePricings = res?.data?.payments ?? [];
      yield put(changeMenuValue("priceItemModal", false));
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("saved_pricings_details", savePricings));
}

function* deleteEditMenuPricingsDetails(action) {
  const res = yield call(
    menuServices.deleteEditMenuPricingsDetails,
    action?.payload
  );
  let savePricings = [];
  console.log("DELETE_EDIT_MENU_PRICINGS", res);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      savePricings = res?.data?.payments ?? [];
      yield put(changeMenuValue("priceItemModal", false));
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("saved_pricings_details", savePricings));
}

function* saveAddMenuItemDetails(action) {
  let res;
  if (checkNull(action?.payload?.id, false)) {
    res = yield call(
      menuServices.editAddMenuItemDetails,
      `/${action?.payload?.id}`,
      action?.payload
    );
  } else {
    res = yield call(menuServices.saveAddMenuItemDetails, action?.payload);
  }
  console.log("SAVE_ADD_MENU_ITEM", res);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(changeMenuValue("is_redirect_flag", true));
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* getEditMenuPricingsDetails(action) {
  let editDetails = null;
  const res = yield call(
    menuServices.getEditMenuPricingsDetails,
    action?.query
  );
  console.log("GET_EDIT_MENU_PRICINGS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_EDIT_MENU_PRICINGS", res?.data);
      editDetails = res?.data?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("edit_pricings_details", editDetails));
  if (editDetails !== null) {
    yield put(changeMenuValue("priceItemModal", true));
  }
}
function* getEditMenuEditPricingsDetails(action) {
  let editDetails = null;
  const res = yield call(
    menuServices.getEditMenuEditPricingsDetails,
    action?.query
  );
  console.log("GET_EDIT_MENU_EDIT_PRICINGS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_EDIT_MENU_EDIT_PRICINGS", res?.data);
      editDetails = res?.data?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("edit_pricings_details", editDetails));
  if (editDetails !== null) {
    yield put(changeMenuValue("priceItemModal", true));
  }
}

function* getMenuListDetails(action) {
  let menuList = [];
  const res = yield call(menuServices.getMenuListDetails, action?.payload);
  console.log("GET_MENU_LIST", res);
  if (res) {
    if (res?.status) {
      console.log("GET_MENU_LIST", res?.data);
      menuList = res?.data?.menus ?? [];
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("menu_item_list", menuList));
}
function* getCostPerItemDetails(action) {
  let costPerItem = [];
  const res = yield call(menuServices.getCostPerItemDetails, action?.payload);
  console.log("GET_COST_PER_ITEM", res);
  if (res) {
    if (res?.status) {
      console.log("GET_COST_PER_ITEM", res?.data);
      costPerItem = res?.data ?? [];
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("cost_per_item", costPerItem));
}

function* getEditMenuItemDetails(action) {
  let editMenuDetail = null;
  yield put(changeMenuValue("add_item_details", editMenuDetail));
  const res = yield call(menuServices.getEditMenuItemDetails, action?.query);
  console.log("GET_EDIT_MENU_ITEM", res);
  if (res) {
    if (res?.status) {
      console.log("GET_EDIT_MENU_ITEM", res?.data);
      editMenuDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("add_item_details", editMenuDetail));
  if (editMenuDetail === null) {
    yield put(changeMenuValue("is_redirect_flag", true));
  }
  yield put(getEditMenuPricingList(action?.query));
}

function* getMenuItemModifiersDetails(action) {
  let itemModifiersDetail = null;
  yield put(changeMenuValue("item_modifiers_details", itemModifiersDetail));
  const res = yield call(
    menuServices.getMenuItemModifiersDetails,
    action?.query
  );
  console.log("GET_MENU_ITEM_MODIFIERS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_MENU_ITEM_MODIFIERS", res?.data);
      itemModifiersDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("item_modifiers_details", itemModifiersDetail));
  if (itemModifiersDetail === null) {
    yield put(changeMenuValue("is_redirect_flag", true));
  }
  yield put(getEditMenuPricingList(action?.query));
}

function* getCostPerMenuItemDetails(action) {
  const menuReducer = yield select((state) => state?.menuReducer);
  const costPriceInput = action?.costPriceInput ?? "cost_per_menu_item";
  const fromPage = action?.fromPage ?? "item_modifiers_details";
  const selectedKey = menuReducer?.[fromPage];
  let unitPriceDetail = null;
  yield put(
    changeMenuValue(fromPage, {
      ...selectedKey,
      [costPriceInput]: unitPriceDetail,
    })
  );
  const res = yield call(menuServices.getCostPerItemDetails, action?.payload);
  console.log("GET_COST_PER_MENU_ITEM", res);
  if (res) {
    if (res?.status) {
      console.log("GET_COST_PER_MENU_ITEM", res?.data);
      unitPriceDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(
    changeMenuValue(fromPage, {
      ...selectedKey,
      [costPriceInput]: unitPriceDetail,
    })
  );
}

function* saveMenuItemModifierDetails(action) {
  let bundleModifiersArr = item_modifiers_details?.bundle_item_modifiers ?? [];
  let standardModifiersArr = item_modifiers_details?.standard_modifiers ?? [];
  let modifiersArr = item_modifiers_details?.modifiers ?? [];
  const item_modifiers_details = yield select(
    (state) => state?.menuReducer?.item_modifiers_details
  );
  let res;
  // if(checkNull(action?.payload?.id,false)){
  //   res = yield call(
  //     menuServices.editAddMenuItemDetails,
  //     `/${action?.payload?.id}`,
  //     action?.payload
  //   );
  // }else{
  res = yield call(menuServices.saveMenuItemModifierDetails, action?.payload);
  // }
  console.log("SAVE_ADD_MENU_ITEM", res);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      if (checkNull(res?.data, false)) {
        bundleModifiersArr = checkArray(res?.data?.bundle_item_modifiers)
          ? res?.data?.bundle_item_modifiers
          : bundleModifiersArr;
        standardModifiersArr = checkArray(res?.data?.standard_modifiers)
          ? res?.data?.standard_modifiers
          : standardModifiersArr;
        modifiersArr = checkArray(res?.data?.modifiers)
          ? res?.data?.modifiers
          : modifiersArr;
      }
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  const itemModifiersDetail = deepCopy(item_modifiers_details);
  itemModifiersDetail.bundle_item_modifiers = bundleModifiersArr;
  itemModifiersDetail.standard_modifiers = standardModifiersArr;
  itemModifiersDetail.modifiers = modifiersArr;
  yield put(changeMenuValue("item_modifiers_details", itemModifiersDetail));
}

function* deleteMenuItemModifierDetails(action) {
  let bundleModifiersArr = item_modifiers_details?.bundle_item_modifiers ?? [];
  let standardModifiersArr = item_modifiers_details?.standard_modifiers ?? [];
  let modifiersArr = item_modifiers_details?.modifiers ?? [];
  const item_modifiers_details = yield select(
    (state) => state?.menuReducer?.item_modifiers_details
  );
  let res;
  // if(checkNull(action?.payload?.id,false)){
  //   res = yield call(
  //     menuServices.editAddMenuItemDetails,
  //     `/${action?.payload?.id}`,
  //     action?.payload
  //   );
  // }else{
  res = yield call(menuServices.deleteMenuItemModifierDetails, action?.payload);
  // }
  console.log("SAVE_ADD_MENU_ITEM", res);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      if (checkNull(res?.data, false)) {
        bundleModifiersArr = checkArray(res?.data?.bundle_item_modifiers)
          ? res?.data?.bundle_item_modifiers
          : bundleModifiersArr;
        standardModifiersArr = checkArray(res?.data?.standard_modifiers)
          ? res?.data?.standard_modifiers
          : standardModifiersArr;
        modifiersArr = checkArray(res?.data?.modifiers)
          ? res?.data?.modifiers
          : modifiersArr;
      }
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  const itemModifiersDetail = deepCopy(item_modifiers_details);
  itemModifiersDetail.bundle_item_modifiers = bundleModifiersArr;
  itemModifiersDetail.standard_modifiers = standardModifiersArr;
  itemModifiersDetail.modifiers = modifiersArr;
  yield put(changeMenuValue("item_modifiers_details", itemModifiersDetail));
}
function* deleteMenuBundleItemModifierDetails(action) {
  let bundleModifiersArr = item_modifiers_details?.bundle_item_modifiers ?? [];
  let standardModifiersArr = item_modifiers_details?.standard_modifiers ?? [];
  let modifiersArr = item_modifiers_details?.modifiers ?? [];
  const item_modifiers_details = yield select(
    (state) => state?.menuReducer?.item_modifiers_details
  );
  let res;
  // if(checkNull(action?.payload?.id,false)){
  //   res = yield call(
  //     menuServices.editAddMenuItemDetails,
  //     `/${action?.payload?.id}`,
  //     action?.payload
  //   );
  // }else{
  res = yield call(
    menuServices.deleteMenuBundleItemModifierDetails,
    action?.payload
  );
  // }
  console.log("SAVE_ADD_MENU_ITEM", res);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      if (checkNull(res?.data, false)) {
        bundleModifiersArr = checkArray(res?.data?.bundle_item_modifiers)
          ? res?.data?.bundle_item_modifiers
          : bundleModifiersArr;
        standardModifiersArr = checkArray(res?.data?.standard_modifiers)
          ? res?.data?.standard_modifiers
          : standardModifiersArr;
        modifiersArr = checkArray(res?.data?.modifiers)
          ? res?.data?.modifiers
          : modifiersArr;
      }
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  const itemModifiersDetail = deepCopy(item_modifiers_details);
  itemModifiersDetail.bundle_item_modifiers = bundleModifiersArr;
  itemModifiersDetail.standard_modifiers = standardModifiersArr;
  itemModifiersDetail.modifiers = modifiersArr;
  yield put(changeMenuValue("item_modifiers_details", itemModifiersDetail));
}

function* getCopyBundleModifierDetails(action) {
  let copyModifierDetails = null;
  const res = yield call(
    menuServices.getCopyBundleModifierDetails,
    action?.query
  );
  console.log("GET_COPY_BUNDLE_MODIFIER", res);
  if (res) {
    if (res?.status && checkNull(res?.data, false)) {
      copyModifierDetails = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("copy_modifier_details", copyModifierDetails));
}

function* getBundleModifierForCopyDetails(action) {
  let modifiersDetails = null;
  const copy_modifier_details = yield select(
    (state) => state?.menuReducer?.copy_modifier_details
  );
  const res = yield call(
    menuServices.getBundleModifierForCopyDetails,
    action?.query
  );
  console.log("GET_BUNDLE_MODIFIER_FOR_COPY", res);
  if (res) {
    if (res?.status && checkNull(res?.data, false)) {
      modifiersDetails = res?.data?.modifier_array ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(
    changeMenuValue("copy_modifier_details", {
      ...copy_modifier_details,
      modifiers: modifiersDetails,
    })
  );
}

function* saveCopyBundleModifierDetails(action) {
  const item_modifiers_details = yield select(
    (state) => state?.menuReducer?.item_modifiers_details
  );
  const itemModifiersDetail = deepCopy(item_modifiers_details);
  let bundleModifiersArr = itemModifiersDetail?.bundle_item_modifiers ?? [];
  let standardModifiersArr = itemModifiersDetail?.standard_modifiers ?? [];
  let modifiersArr = itemModifiersDetail?.modifiers ?? [];
  let res;
  res = yield call(menuServices.saveCopyBundleModifier, action?.query, action?.payload);
  console.log("SAVE_COPY_BUNDLE_MODIFIER", res);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      if (checkNull(res?.data, false)) {
        bundleModifiersArr = checkArray(res?.data?.bundle_item_modifiers)
          ? res?.data?.bundle_item_modifiers
          : bundleModifiersArr;
        standardModifiersArr = checkArray(res?.data?.standard_modifiers)
          ? res?.data?.standard_modifiers
          : standardModifiersArr;
        modifiersArr = checkArray(res?.data?.modifiers)
          ? res?.data?.modifiers
          : modifiersArr;
      }
      yield put(changeMenuValue("copyModifierModal", false));
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  
  itemModifiersDetail.bundle_item_modifiers = bundleModifiersArr;
  itemModifiersDetail.standard_modifiers = standardModifiersArr;
  itemModifiersDetail.modifiers = modifiersArr;
  yield put(changeMenuValue("item_modifiers_details", itemModifiersDetail));
}

function* editMenuBundleItemModifierDetails(action) {
  let editModifierDetails = null;
  const res = yield call(
    menuServices.editMenuBundleItemModifierDetails,
    action?.query
  );
  console.log("EDIT_MENU_BUNDLE_ITEM_MODIFIER", res);
  if (res) {
    if (res?.status && checkNull(res?.data, false)) {
      editModifierDetails = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeMenuValue("edit_modifier_details", editModifierDetails));
}

function* menuSaga() {
  // menu Pricing
  yield takeLatest(actionTypes.GET_MENU_PRICING_DETAILS, getMenuPricingDetails);
  yield takeLatest(
    actionTypes.POST_MENU_PRICING_DETAILS,
    postMenuPricingDetails
  );

  yield takeLatest(
    actionTypes.GET_SCHEDULED_MENU_PRICING_DETAILS,
    getScheduledMenuPricingDetails
  );
  yield takeLatest(actionTypes.SEARCH_MENU_BY_NAME, searchMenuByName);
  yield takeLatest(actionTypes.GET_SALES_TYPE, getSalesType);
  yield takeLatest(
    actionTypes.POST_SCHEDULED_MENU_PRICING_DETAILS,
    postScheduledMenuPricingDetails
  );
  yield takeLatest(
    actionTypes.DELETE_SCHEDULED_MENU_ITEM,
    deleteScheduledMenuItem
  );

  yield takeLatest(actionTypes.GET_MENU_INGREDIENTS, getMenuIngredientDetails);
  yield takeLatest(
    actionTypes.ADD_MENU_INGREDIENT_DETAILS,
    addMenuIngredientDetail
  );
  yield takeLatest(actionTypes.CHECK_SUPPLIER_DETAILS, checkSupplierDetails);
  yield takeLatest(
    actionTypes.SAVE_STORAGE_AREA_DETAILS,
    saveStorageAreaDetails
  );
  yield takeLatest(
    actionTypes.GET_CONVERSION_MULTIPLIER,
    getConversionMultiplierDetails
  );
  yield takeLatest(
    actionTypes.SAVE_MENU_INGREDIENT_DETAILS,
    saveMenuIngredientDetail
  );
  yield takeLatest(actionTypes.GET_INVENTORY_UOM, getInventoryUomDetail);
  yield takeLatest(
    actionTypes.SAVE_BACKUP_INGREDIENT,
    saveBackupIngredientDetail
  );
  yield takeLatest(
    actionTypes.GET_BACKUP_INGREDIENT,
    getBackupIngredientDetail
  );
  yield takeLatest(actionTypes.GET_EDIT_INGREDIENT, getEditIngredientDetail);
  yield takeLatest(
    actionTypes.GET_INGRE_MENU_APPROVAL,
    getIngrRecMenuPendingApprovalDetail
  );
  yield takeLatest(
    actionTypes.CHANGE_PEND_INGREDIENT_STATUS,
    changePendIngredientStatusDetail
  );
  yield takeLatest(
    actionTypes.CHANGE_INGREDIENT_STATUS,
    changeIngredientStatusDetail
  );
  yield takeLatest(actionTypes.GET_MENU_RECIPE, getMenuRecipeDetails);
  yield takeLatest(actionTypes.ADD_MENU_RECIPE_DETAILS, addMenuRecipeDetail);
  yield takeLatest(actionTypes.GET_MEASUREMENT_UNIT, getMeasurementUnitDetails);
  yield takeLatest(
    actionTypes.GET_RECIPE_COST_PRICE,
    getRecipeCostPriceDetails
  );
  yield takeLatest(
    actionTypes.GET_RECIPE_MULTIPLIER,
    getRecipeMultiplierDetails
  );
  yield takeLatest(
    actionTypes.GET_RECIPE_UNIT_PRICE,
    getRecipeUnitPriceDetails
  );
  yield takeLatest(actionTypes.SAVE_MENU_RECIPE_DETAILS, saveMenuRecipeDetail);
  yield takeLatest(actionTypes.GET_EDIT_RECIPE, getEditRecipeDetail);
  yield takeLatest(
    actionTypes.CHANGE_PEND_RECIPE_STATUS,
    changePendRecipeStatusDetail
  );
  yield takeLatest(actionTypes.GET_MENU_ITEMS, getMenuItemsDetails);
  yield takeLatest(
    actionTypes.GET_MENU_ITEM_SUB_CLASS,
    getMenuItemSubClassDetails
  );
  yield takeLatest(
    actionTypes.GET_MENU_ITEM_SUB_CATEGORY,
    getMenuItemSubCategoryDetails
  );
  yield takeLatest(
    actionTypes.UPDATE_MENU_ITEM_CLASS,
    updateMenuItemClassDetails
  );
  yield takeLatest(
    actionTypes.UPDATE_MENU_ITEM_CATEGORY,
    updateMenuItemCategoryDetails
  );
  yield takeLatest(
    actionTypes.UPDATE_MENU_ITEM_STATUS,
    updateMenuItemStatusDetails
  );
  yield takeLatest(
    actionTypes.EDIT_MENU_ITEM_LIFESPAN,
    editMenuItemLifespanDetails
  );
  yield takeLatest(
    actionTypes.UPDATE_MENU_ITEM_LIFESPAN,
    updateMenuItemLifespanDetails
  );
  yield takeLatest(actionTypes.GET_ADD_MENU_ITEM, getAddMenuItemDetails);
  yield takeLatest(actionTypes.GET_MENU_ITEM_CA, getMenuItemCaDetails);
  yield takeLatest(
    actionTypes.GET_MENU_MEASUREMENT_UNIT,
    getMenuMeasurementUnitDetails
  );
  yield takeLatest(actionTypes.GET_MENU_UNIT_PRICE, getMenuUnitPriceDetails);
  yield takeLatest(actionTypes.GET_MENU_MULTI_UNIT, getMenuMultiUnitDetails);
  yield takeLatest(
    actionTypes.GET_ADD_MENU_PRICINGS,
    getAddMenuPricingsDetails
  );
  yield takeLatest(
    actionTypes.GET_MENU_EDIT_PRICINGS,
    getMenuEditPricingsDetails
  );
  yield takeLatest(
    actionTypes.GET_MENU_PRICING_LIST,
    getMenuPricingListDetails
  );
  yield takeLatest(
    actionTypes.SAVE_ADD_MENU_PRICINGS,
    saveAddMenuPricingsDetails
  );
  yield takeLatest(
    actionTypes.SAVE_EDIT_MENU_PRICINGS,
    saveEditMenuPricingsDetails
  );
  yield takeLatest(
    actionTypes.GET_EDIT_MENU_PRICINGS,
    getEditMenuPricingsDetails
  );
  yield takeLatest(
    actionTypes.GET_EDIT_MENU_EDIT_PRICINGS,
    getEditMenuEditPricingsDetails
  );
  yield takeLatest(
    actionTypes.GET_EDIT_MENU_PRICING_LIST,
    getEditMenuPricingListDetails
  );
  yield takeLatest(actionTypes.DELETE_MENU_PRICINGS, deleteMenuPricingsDetails);
  yield takeLatest(
    actionTypes.DELETE_EDIT_MENU_PRICINGS,
    deleteEditMenuPricingsDetails
  );
  yield takeLatest(actionTypes.SAVE_ADD_MENU_ITEM, saveAddMenuItemDetails);
  yield takeLatest(actionTypes.GET_MENU_LIST, getMenuListDetails);
  yield takeLatest(actionTypes.GET_COST_PER_ITEM, getCostPerItemDetails);
  yield takeLatest(actionTypes.GET_EDIT_MENU_ITEM, getEditMenuItemDetails);
  yield takeLatest(
    actionTypes.GET_MENU_ITEM_MODIFIERS,
    getMenuItemModifiersDetails
  );
  yield takeLatest(
    actionTypes.GET_COST_PER_MENU_ITEM,
    getCostPerMenuItemDetails
  );
  yield takeLatest(
    actionTypes.SAVE_MENU_ITEM_MODIFIER,
    saveMenuItemModifierDetails
  );
  yield takeLatest(
    actionTypes.DELETE_MENU_ITEM_MODIFIER,
    deleteMenuItemModifierDetails
  );
  yield takeLatest(
    actionTypes.DELETE_MENU_BUNDLE_ITEM_MODIFIER,
    deleteMenuBundleItemModifierDetails
  );
  yield takeLatest(
    actionTypes.GET_COPY_BUNDLE_MODIFIER,
    getCopyBundleModifierDetails
  );
  yield takeLatest(
    actionTypes.GET_BUNDLE_MODIFIER_FOR_COPY,
    getBundleModifierForCopyDetails
  );
  yield takeLatest(
    actionTypes.SAVE_COPY_BUNDLE_MODIFIER,
    saveCopyBundleModifierDetails
  );
  yield takeLatest(
    actionTypes.EDIT_MENU_BUNDLE_ITEM_MODIFIER,
    editMenuBundleItemModifierDetails
  );
}

export default menuSaga;
